"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.LinkSVG = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _Icon = require("../Icon");
var _excluded = ["children"];
var innerSvg = '<path d="M17.76,21.56a7.43,7.43,0,0,1-5.26-2.18,2,2,0,1,1,2.83-2.83,3.53,3.53,0,0,0,4.87,0l4.67-4.67A3.44,3.44,0,1,0,20,7L18.08,8.93a2,2,0,0,1-2.83-2.82l1.92-1.93A7.45,7.45,0,1,1,27.7,14.71L23,19.38A7.44,7.44,0,0,1,17.76,21.56Z"/><path d="M9.32,30A7.45,7.45,0,0,1,4.06,17.29l4.67-4.67a7.46,7.46,0,0,1,10.53,0,2,2,0,0,1-2.83,2.83,3.53,3.53,0,0,0-4.87,0L6.89,20.12A3.44,3.44,0,0,0,11.76,25l1.92-1.92a2,2,0,0,1,2.83,2.82l-1.92,1.93A7.44,7.44,0,0,1,9.32,30Z"/>';
var LinkSVG = function LinkSVG(_ref) {
  var children = _ref.children,
    rest = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
    viewBox: "0 0 32 32"
  }, rest), children, /*#__PURE__*/_react.default.createElement("g", {
    stroke: "none",
    dangerouslySetInnerHTML: {
      __html: innerSvg
    }
  }));
};
exports.LinkSVG = LinkSVG;
LinkSVG.propTypes = process.env.NODE_ENV !== "production" ? {
  children: _propTypes.default.node
} : {};
var _default = (0, _Icon.withIcon)(LinkSVG);
exports.default = _default;